/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Email_SendInputs */

const en_task_email_send = /** @type {(inputs: Task_Email_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send email`)
};

const pt_br2_task_email_send = /** @type {(inputs: Task_Email_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar e-mail`)
};

/**
* | output |
* | --- |
* | "Send email" |
*
* @param {Task_Email_SendInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_send = /** @type {((inputs?: Task_Email_SendInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_SendInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_send(inputs)
	return pt_br2_task_email_send(inputs)
});